module.exports = __webpack_public_path__ + "img/no-results.56ff2aa6.svg";